module.exports = __webpack_public_path__ + "static/media/BS_O_Embroidery_Bicocca_White_IndBlue.646c0347.png";